<template lang="pug">
  div
    section.content-header
      h1 Sales Force Assistant 連携
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active Sales Force Assistant 連携

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'admin'}")
                button.btn.btn-default キャンセル

        +btnbar

        .callout.callout-info.bcard-callout
          h4 Sales Force Assistant に名刺情報を連携します。
          p
            | 登録した名刺情報を Sales Force Assistant の パーソン情報にご利用いただけます。
            br
            | Sales Force Assistant 連携機能を使用する場合は、連携先URLの設定を行ってください。

        //- 読み込み中はぐるぐる表示
        .panel.panel-default(v-if="isLoading")
          loading

        //- 読み込み中は表示しない
        .box.box-widget(v-if="!isLoading")
          .box-body
            .form-group
              label.control-label Sales Force Assistant 連携機能
              .radio.radio-rich
                label.radio-inline
                  input(type="radio" v-model="item.enable" :value="app_flag.OFF")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;使用しない
                label.radio-inline
                  input(type="radio" v-model="item.enable" :value="app_flag.ON")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;使用する

            hr

            .form-group
              label.control-label(for="bcard-integration-url") 連携先URL
                span.bcard-required(v-if="isUrlRequired") (*)
              input#bcard-integration-url.form-control(type="text" v-model="item.url", :maxlength="maxlengths.url" :required="isUrlRequired")

            .help-block
              p.bcard-comments.text-info
                | ※ Sales Force Assistant 名刺情報受信APIのURLを入力してください。

            //-作ったけど不要だった・・・
            //-.bcard-btnbar
            //-  button.btn.btn-info(type="button" @click="testConnection", :disabled="disableField") 接続確認
            //-app-messages(:errorMessages="testErrors", :successMessages="testSuccesses")

            .help-block
              p.bcard-required ※ (*)は必須項目です。

        +btnbar.-bottom

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import mixinForm from '@/mixins/form'

const NisfaIntegrationRepository = RepositoryFactory.get('nisfaintegration')

export default {
  name: 'NisfaIntegrationSettings',
  components: { AppMessages, Loading },
  mixins: [ mixinForm ],
  data: function () {
    return {
      isLoading: true, // 読み込み中かどうか
      maxlengths: {},

      item: {
        enable: '',
        url: ''
      }

      // testErrors: [],
      // testSuccesses: []
    }
  },
  computed: {
    // disableField: function () {
    //   return this.item.enable === this.app_flag.OFF
    // },
    isUrlRequired () {
      return this.item.enable === this.app_flag.ON
    }
  },
  // 最初にこの機能に入ってきたときに実行される
  created: function () {
    const vm = this
    this.maxlengths = this.loadMaxlengths('NisfaIntegration')

    // API実行
    NisfaIntegrationRepository.get()
      .then(function (response) {
        const res = vm.getApiData(response).data
        // responseの入れ替え
        Object.keys(vm.item).forEach(itemKey => {
          vm.item[itemKey] = res[itemKey]
        })
        vm.isLoading = false
      })
      .catch(function (error) {
        // エラーコードが4013（契約なし）の場合、未契約ページを表示する
        const appCode = error.response ? vm.getAppErrCode(error.response.data.data.message) : ''
        if (appCode === '4013') {
          // APIからのエラーメッセージを流用したい場合はparamsに埋めることも可
          vm.$router.push({name: 'page-unlicensed'})
        }
        else {
          vm.setErrorMessage(error)
        }
      })
  },
  // データの保存期間設定共通メソッド
  methods: {
    // 送信処理
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this

      const sendData = {}

      Object.keys(vm.item).forEach(itemKey => {
        sendData[itemKey] = vm.item[itemKey]
      })

      // API実行
      NisfaIntegrationRepository.put(sendData)
        .then(function () {
          // 処理成功時はTOPに遷移する
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
        // エラーメッセージを出す
          vm.setErrorMessage(error)
        })
    }
    // testConnection () {
    //   this.testErrors = []
    //   this.testSuccesses = []
    //
    //   if (this.item.url.length === 0) {
    //     this.testErrors.push('連携先URLを入力してください。')
    //     return
    //   }
    //
    //   // API実行
    //   const vm = this
    //   NisfaIntegrationRepository.test({
    //     url: this.item.url
    //   })
    //     .then(function (response) {
    //       if (vm.isApiSuccess(response)) {
    //         vm.testSuccesses.push('Sales Force Assistantへの接続に成功しました。')
    //       }
    //       else {
    //         const message = response.data.message || 'Sales Force Assistantへの接続確認に失敗しました。'
    //         vm.testErrors.push(message)
    //       }
    //     }).catch(function (error) {
    //       const message = vm.getErrorMessage(error)
    //       vm.testErrors.push(message)
    //     })
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/NisfaIntegrationSettings.vue